/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductAvailabilityNotificationFormComponent } from './product-availability-notification-form.component';
import { ProductAvailabilityNotificationGoldMessageModule } from '@pdp/exclusive-products/components';
import { ProductRecommendationsComponent } from '@product-recommendations/components';
import { ReactiveFormsModule } from '@angular/forms';
import {
	HmfAlertBannerComponent,
	HmfButtonComponent,
	HmfTextInputComponent
} from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	homefieldIconSignCircledCheck,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

@NgModule({
	imports: [
		CommonModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfTextInputComponent,
		HomefieldIconLibraryModule,
		ProductAvailabilityNotificationGoldMessageModule,
		ProductRecommendationsComponent,
		ReactiveFormsModule
	],
	declarations: [ProductAvailabilityNotificationFormComponent],
	exports: [ProductAvailabilityNotificationFormComponent]
})
export class ProductAvailabilityNotificationFormModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCircledCheck]);
	}
}
